import React from "react";
import { useTranslation } from "react-i18next";
import {
	Box,
	Typography,
	Stack,
	Button,
	Chip,
	IconButton,
	Tooltip,
} from "@mui/joy";
import PropTypes from "prop-types";
import SimpleTable from "UI/Tables/SimpleTable/SimpleTable";
import InfiniteScroll from "react-infinite-scroll-component";
import Helpers from "utils/Helpers";
import { WhiteContainer } from "UI";
import { RemoveRedEye, Edit, Delete, Storage } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

const Groups = ({ groups, getGroups, setGroups, isMore }) => {
	const { t } = useTranslation();
	const history = useHistory();
	const TypographyStyle = {
		maxWidth: "100%",
		overflow: "hidden",
		textOverflow: "ellipsis",
	};
	const columns = ["Nom", t("place_nbr"), ""];
	const actions = [
		(d) => (
			<Stack direction="row" spacing={1}>
				<IconButton
					variant="outlined"
					color="primary"
					component={Link}
					//to={`/groups/edit/${d.id}`}
					to={`/admin/groups/${d.id}`}
				>
					<Edit />
				</IconButton>
				<Tooltip title={t("display_in_db")}>
					<IconButton
						variant="outlined"
						color="primary"
						component={"a"}
						href={`https://console.firebase.google.com/project/weevuptools/firestore/databases/-default-/data/groups/${d.id}`}
						target={"_blank"}
					>
						<Storage />
					</IconButton>
				</Tooltip>
			</Stack>
		),
	];

	const fields = {
		name: (v) => <Typography sx={TypographyStyle}>{v}</Typography>,
		places: (v) => (
			<Typography sx={TypographyStyle}>{v?.length}</Typography>
		),
	};

	return (
		<WhiteContainer>
			<Box
				id="ed"
				sx={{ height: "60vh", width: "100%", overflowY: "scroll" }}
			>
				<InfiniteScroll
					dataLength={groups.length}
					scrollableTarget="ed"
					next={getGroups}
					hasMore={isMore}
					loader={<h4>{t("loading")}...</h4>}
				>
					<SimpleTable
						inputProps={{
							stickyHeader: true,
							stickyFooter: true,
							hoverRow: true,
							borderAxis: "both",
						}}
						style={{
							maxWidth: "100%",
							overflow: "auto",
							background: "white",
							borderRadius: "10px",
							mb: 2,
						}}
						head={columns}
						datas={groups}
						fields={fields}
						actions={actions}
					/>{" "}
				</InfiniteScroll>
			</Box>
		</WhiteContainer>
	);
};

export default Groups;
Groups.propTypes = {
	getGroups: PropTypes.func,
	groups: PropTypes.array,
	setGroups: PropTypes.func,
};
Groups.defaultProps = {
	groups: [],
};
